import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DeleteSLAsRequestDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export interface UseDeleteSLAParams {
  onError?: (error: ExtendedAxiosError) => void;
  onSuccess?: () => void;
}

export function useDeleteSLAs({ onError, onSuccess }: UseDeleteSLAParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<void, ExtendedAxiosError, DeleteSLAsRequestDto>({
    mutationKey: ['sla'],
    mutationFn: (r) => api.slasApi.deleteSLAs(r).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['slas'],
      });
      onSuccess?.();
    },
    onError,
  });
}
